export type ScannedContact = Partial<Record<
    "firstName" | "middleName" | "lastName" | "email1" | "email2" |
    "phoneNumber" | "directNumber" | "fax" | "extension" | "role" | "background", string
>>;

// Keep the original text: card layouts vary, so every suggestion needs review.
export function parseContactScan(text: string): ScannedContact {
    const result: ScannedContact = { background: text.trim() };
    const emails = Array.from(new Set(text.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi) || []));
    if (emails[0]) result.email1 = emails[0];
    if (emails[1]) result.email2 = emails[1];
    const lines = text.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
    const rolePattern = /\b(?:manager|director|president|engineer|architect|owner|founder|consultant|superintendent|coordinator|sales|estimator|CEO|COO|CFO|CTO)\b/i;
    result.role = lines.find(line => rolePattern.test(line) && !line.includes("@")) || "";
    for (const line of lines) {
        const phones = line.matchAll(/(?:\+?1[ .-]?)?\(?\d{3}\)?[ .-]?\d{3}[ .-]?\d{4}\b/g);
        for (const match of Array.from(phones)) {
            const digits = match[0].replace(/\D/g, "").slice(-10);
            const number = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
            const label = line.slice(0, match.index).split(/[|;]/).pop() || "";
            if (/\b(?:fax|f)\s*[:.]?\s*$/i.test(label)) result.fax = number;
            else if (/\b(?:mobile|cell|direct|m|c|d)\s*[:.]?\s*$/i.test(label)) result.directNumber = number;
            else if (!result.phoneNumber) result.phoneNumber = number;
            else if (!result.directNumber) result.directNumber = number;
        }
    }
    const extension = text.match(/\b(?:ext\.?|extension|x)\s*:?\s*(\d{1,6})\b/i);
    if (extension) result.extension = extension[1];
    const name = lines.find(line =>
        /^[\p{L}][\p{L}'.-]*(?:\s+[\p{L}][\p{L}'.-]*){1,3}$/u.test(line) &&
        !rolePattern.test(line) &&
        !/\b(?:inc|llc|ltd|corp|company|construction|services|group|solutions|street|road|avenue|www)\b/i.test(line)
    );
    if (name) {
        const parts = name.split(/\s+/);
        result.firstName = parts[0];
        result.lastName = parts[parts.length - 1];
        result.middleName = parts.slice(1, -1).join(" ");
    }
    return result;
}
